import $ from 'jquery';
import moment from 'moment';

export const index = () => {
  const $form = $('form.search');

  // Enabling calendar on search form
  $form.find('.ui.calendar').calendarFr({
    type: 'date',
    parser: {
      date: (text, settings) => moment(text, 'DD/MM/YYYY').toDate(),
    },
    formatter: {
      datetime: date => {
        if (!date) {
          return '';
        }

        return moment(date).format('DD/MM/YYYY');
      },
    },
    onChange: date => {
      $form.find('input[name="date"]').val(moment(date).format('DD/MM/YYYY'));
      $form.submit();
    },
  });
};



// WEBPACK FOOTER //
// ./src/modules/admin/events/index.js